(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vitto-bundle-selector"] && !Shopify.designMode) return;
  try {
    function initVittoBundle() {

  document
    .querySelectorAll('[data-vitto-bundle]')
    .forEach((bundle) => {

      if (bundle.dataset.initialized === 'true') {
        return;
      }

      bundle.dataset.initialized = 'true';


      const offers =
        Array.from(
          bundle.querySelectorAll('[data-vitto-offer]')
        );


      const message =
        bundle.querySelector('[data-vitto-message]');


      const gallery =
        bundle.querySelector('[data-vitto-gallery]');


      const closeGalleryButton =
        bundle.querySelector('[data-vitto-close-gallery]');


      const productCards =
        Array.from(
          bundle.querySelectorAll('[data-vitto-product]')
        );


      const productFormId =
        bundle.dataset.productFormId;


      const productForm =
        productFormId
          ? document.getElementById(productFormId)
          : null;


      let activePicker = null;


      /* CAMBIAR PACK */

      offers.forEach((offer) => {

        const radio =
          offer.querySelector(
            'input[type="radio"]'
          );


        radio.addEventListener(
          'change',
          () => {

            offers.forEach((item) => {

              item.classList.remove(
                'is-selected'
              );

            });


            offer.classList.add(
              'is-selected'
            );


            if (gallery) {
              gallery.hidden = true;
            }


            activePicker = null;

            message.textContent = '';

          }
        );

      });


      /* ACTUALIZAR PRODUCTO */

      function updatePicker(picker) {

        if (!picker) return;


        const select =
          picker.querySelector(
            '[data-vitto-select]'
          );


        if (!select) return;


        const option =
          select.options[
            select.selectedIndex
          ];


        if (!option) return;


        const image =
          picker.querySelector(
            '[data-vitto-image]'
          );


        const name =
          picker.querySelector(
            '[data-vitto-name]'
          );


        const stockText =
          picker.querySelector(
            '[data-vitto-stock]'
          );


        const imageUrl =
          option.dataset.image || '';


        const title =
          option.dataset.title || 'Perfume';


        const stock =
          Number(
            option.dataset.stock || 0
          );


        const tracksStock =
          option.dataset.trackStock ===
          'true';


        if (image) {
          image.src = imageUrl;
          image.alt = title;
        }


        if (name) {
          name.textContent = title;
        }


        if (stockText) {

          stockText.classList.remove(
            'is-low-stock'
          );


          if (tracksStock) {

            if (stock === 1) {

              stockText.textContent =
                '🔥 ¡ÚLTIMA UNIDAD!';

              stockText.classList.add(
                'is-low-stock'
              );

            } else if (
              stock > 1 &&
              stock <= 3
            ) {

              stockText.textContent =
                '🔥 ¡QUEDAN SOLO ' +
                stock +
                '!';

              stockText.classList.add(
                'is-low-stock'
              );

            } else {

              stockText.textContent =
                'Stock disponible: ' +
                Math.max(stock, 0);

            }

          } else {

            stockText.textContent =
              'Disponible';

          }

        }

      }


      bundle
        .querySelectorAll(
          '[data-vitto-picker]'
        )
        .forEach((picker) => {

          const select =
            picker.querySelector(
              '[data-vitto-select]'
            );


          const openButton =
            picker.querySelector(
              '[data-vitto-open-picker]'
            );


          if (select) {

            select.addEventListener(
              'change',
              () => {

                updatePicker(picker);

              }
            );


            updatePicker(picker);

          }


          if (openButton) {

            openButton.addEventListener(
              'click',
              () => {

                activePicker = picker;


                if (!gallery) return;


                gallery.hidden = false;


                const selectedId =
                  select
                    ? String(select.value)
                    : '';


                productCards.forEach(
                  (card) => {

                    card.classList.toggle(
                      'is-selected',
                      String(
                        card.dataset.variantId
                      ) === selectedId
                    );

                  }
                );


                setTimeout(() => {

                  gallery.scrollIntoView({

                    behavior: 'smooth',

                    block: 'start'

                  });

                }, 50);

              }
            );

          }

        });


      /* ELEGIR PERFUME */

      productCards.forEach((card) => {

        card.addEventListener(
          'click',
          () => {

            if (!activePicker) return;


            const variantId =
              String(
                card.dataset.variantId || ''
              );


            const select =
              activePicker.querySelector(
                '[data-vitto-select]'
              );


            if (!select || !variantId) {
              return;
            }


            select.value = variantId;


            select.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );


            productCards.forEach(
              (item) => {

                item.classList.remove(
                  'is-selected'
                );

              }
            );


            card.classList.add(
              'is-selected'
            );


            if (gallery) {
              gallery.hidden = true;
            }


            activePicker.scrollIntoView({

              behavior: 'smooth',

              block: 'center'

            });


            activePicker = null;

          }
        );

      });


      /* CERRAR GALERÍA */

      if (closeGalleryButton) {

        closeGalleryButton.addEventListener(
          'click',
          () => {

            if (gallery) {
              gallery.hidden = true;
            }

            activePicker = null;

          }
        );

      }


      /* OBTENER ITEMS */

      function getBundleItems() {

        const activeOffer =
          bundle.querySelector(
            '[data-vitto-offer].is-selected'
          );


        if (!activeOffer) {
          return [];
        }


        const selects =
          activeOffer.querySelectorAll(
            '[data-vitto-select]'
          );


        const products =
          new Map();


        selects.forEach((select) => {

          const option =
            select.options[
              select.selectedIndex
            ];


          if (!option) return;


          const id =
            Number(option.value);


          if (!id) return;


          const title =
            option.dataset.title ||
            'Perfume';


          const stock =
            Number(
              option.dataset.stock || 0
            );


          const tracksStock =
            option.dataset.trackStock ===
            'true';


          if (!products.has(id)) {

            products.set(
              id,
              {

                id: id,

                quantity: 0,

                title: title,

                stock: stock,

                tracksStock:
                  tracksStock

              }
            );

          }


          products.get(id).quantity += 1;

        });


        return Array.from(
          products.values()
        );

      }


      /* VALIDAR STOCK */

      function validateStock(items) {

        for (const item of items) {

          if (
            item.tracksStock &&
            item.quantity > item.stock
          ) {

            message.textContent =
              'Solo quedan ' +
              item.stock +
              ' unidades de ' +
              item.title +
              '.';


            return false;

          }

        }


        return true;

      }


      /* AGREGAR AL CARRITO */

      let addingBundle = false;


      async function addBundle(event) {

        if (event) {

          event.preventDefault();

          event.stopPropagation();


          if (
            typeof event
              .stopImmediatePropagation ===
            'function'
          ) {

            event.stopImmediatePropagation();

          }

        }


        if (addingBundle) {
          return;
        }


        const bundleItems =
          getBundleItems();


        if (!bundleItems.length) {

          message.textContent =
            'Elegí tus perfumes.';

          return;

        }


        if (!validateStock(bundleItems)) {
          return;
        }


        addingBundle = true;


        message.textContent =
          'Agregando tus perfumes...';


        const items =
          bundleItems.map(
            (item) => ({

              id: item.id,

              quantity: item.quantity

            })
          );


        try {

          const root =
            window.Shopify?.routes?.root ||
            '/';


          const response =
            await fetch(
              root + 'cart/add.js',
              {

                method: 'POST',

                headers: {

                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'

                },

                body:
                  JSON.stringify({

                    items: items

                  })

              }
            );


          const result =
            await response.json();


          if (!response.ok) {

            throw new Error(
              result.description ||
              result.message ||
              'No se pudieron agregar los perfumes.'
            );

          }


          message.textContent =
            '¡Pack agregado correctamente!';


          window.location.href =
            root + 'cart';


        } catch (error) {

          message.textContent =
            error.message ||
            'Error al agregar el pack.';

        } finally {

          addingBundle = false;

        }

      }


      /* BOTÓN SHRINE */

      if (productForm) {

        productForm.addEventListener(
          'submit',
          addBundle,
          true
        );


        productForm
          .querySelectorAll(
            'button[name="add"]'
          )
          .forEach((button) => {

            button.addEventListener(
              'click',
              addBundle,
              true
            );

          });


        document
          .querySelectorAll(
            'button[name="add"][form="' +
            productFormId +
            '"]'
          )
          .forEach((button) => {

            button.addEventListener(
              'click',
              addBundle,
              true
            );

          });

      }

    });

}


document.addEventListener(
  'DOMContentLoaded',
  initVittoBundle
);


document.addEventListener(
  'shopify:section:load',
  initVittoBundle
);


initVittoBundle();
  } catch(e) { console.error(e); }
})();

})();
